import { Howl, Howler } from 'howler';
import { isMobile } from 'react-device-detect';
import { ALL_SOUND_ASSET_URLS } from '../assets/soundAssetUrls';
import { isTestEnvironment } from './utils';
const SOUND_TO_TYPE = {
    shuffle: 'shuffle',
    flop: 'flop',
    bet: 'bet',
    raise: 'raise',
    allin: 'allin',
    check: 'check',
    fold: 'fold',
    yourturn: 'yourturn',
    win: 'win',
    lose: 'lose',
    showdown: 'showdown',
    add_chips: 'add_chips',
    reveal: 'reveal',
    chat: 'chat',
    time_running_out: 'time_running_out',
    bomb_throw: 'bomb_throw',
    egg1: 'pie',
    egg2: 'pie',
    boom1: 'bomb',
    boom2: 'bomb',
    boom3: 'bomb',
    boom4: 'bomb',
    beer: 'beer',
    fairy: 'heart',
    sheep: 'sheep',
    squish1: 'trash',
    squish2: 'trash',
    squish3: 'trash',
    side_bet: 'side_bet'
};
const CUSTOM_SOUND_VOLUMES = {
    fairy: 0.75
};
// SINGLETON ALERT! (only used for instance id 0)
let soundLibrary;
function createNewSoundLibrary() {
    const newSoundLibrary = {};
    Object.entries(SOUND_TO_TYPE).forEach(([allSoundType, soundOrBombType]) => {
        const howl = new Howl({
            src: [ALL_SOUND_ASSET_URLS[allSoundType]],
            volume: CUSTOM_SOUND_VOLUMES[allSoundType]
        });
        const existingHowlOrArray = newSoundLibrary[soundOrBombType];
        if (!existingHowlOrArray) {
            newSoundLibrary[soundOrBombType] = howl;
        }
        else if (Array.isArray(existingHowlOrArray)) {
            existingHowlOrArray.push(howl);
        }
        else {
            // existingHowlOrArray is a single Howl object, add it and the current howl to a new array:
            newSoundLibrary[soundOrBombType] = [existingHowlOrArray, howl];
        }
    });
    return newSoundLibrary;
}
function initSoundLibrary() {
    soundLibrary = soundLibrary || createNewSoundLibrary();
}
function maybePlaySound(state, soundTypeOrBombType, offset = 0) {
    if (isTestEnvironment()) {
        return;
    }
    if (isMobile && document.visibilityState === 'hidden') {
        // on mobile, if app is in the background, don't attempt to play any sound
        return;
    }
    const instanceId = state.instanceId.instanceId;
    if (instanceId) {
        // Only play sounds for first (or only) app instance.
        return;
    }
    const soundVolume = state.selfData.userClientSettings.SOUND_VOLUME.percent;
    if (soundVolume <= 0) {
        // User sound setting is off, or is muted (muted sound remembers the previous sound level by making the number negative)
        return;
    }
    initSoundLibrary();
    if (!soundLibrary) {
        // should always be defined now, but TypeScript doesn't know that
        return;
    }
    const soundOrArray = soundLibrary[soundTypeOrBombType];
    const sound = Array.isArray(soundOrArray)
        ? soundOrArray[Math.floor(Math.random() * soundOrArray.length)]
        : soundOrArray;
    if (!sound) {
        console.error(`Sound '${soundTypeOrBombType}' was not initialized and could not play!`);
        return;
    }
    // set global volume:
    Howler.volume(soundVolume / 100);
    const soundId = sound.play();
    sound.seek(offset, soundId);
}
export function maybePlayShuffleSound(state) {
    maybePlaySound(state, 'shuffle');
}
export function maybePlayFlopSound(state) {
    maybePlaySound(state, 'flop');
}
export function maybePlayBetOrCallSound(state) {
    maybePlaySound(state, 'bet');
}
export function maybePlayRaiseSound(state) {
    maybePlaySound(state, 'raise');
}
export function maybePlayAllInSound(state) {
    maybePlaySound(state, 'allin');
}
export function maybePlayFoldSound(state) {
    maybePlaySound(state, 'fold');
}
export function maybePlayCheckSound(state) {
    maybePlaySound(state, 'check');
}
export function maybePlayYourTurnSound(state) {
    maybePlaySound(state, 'yourturn');
}
export function maybePlayWinSound(state) {
    maybePlaySound(state, 'win');
}
export function maybePlayLoseSound(state) {
    maybePlaySound(state, 'lose');
}
export function maybePlayShowdownSound(state) {
    maybePlaySound(state, 'showdown');
}
export function maybePlayAddChipsSound(state) {
    maybePlaySound(state, 'add_chips', 0.1);
}
export function maybePlayRevealSound(state) {
    maybePlaySound(state, 'reveal');
}
export function maybePlayChatSound(state) {
    maybePlaySound(state, 'chat');
}
export function maybePlayTimeRunningOutSound(state) {
    maybePlaySound(state, 'time_running_out');
}
export function maybePlayBombThrowSound(state) {
    maybePlaySound(state, 'bomb_throw');
}
export function maybePlayBombSplatSound(state, bombType) {
    maybePlaySound(state, bombType);
}
export function maybePlaySideBetSound(state) {
    maybePlaySound(state, 'side_bet');
}
